<template>
  <div class="slider-container">
    <vue-slider
      class="slider"
      v-bind="options"
      :value="value"
      @change="valueChanged" 
      :disabled="disabled"     
      ref="slider"
    ></vue-slider>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
export default {
  name: "Slider",

  components: {
    VueSlider
  },
  props: ["dataValues", "value", 'disabled'],
  data() {
    return {
      options: {
        data: null,
        tooltip: "always",
        adsorb: true,
        marks: true
      }
    };
  },
  methods: {
    valueChanged(event) {
      this.$emit("input", event);
    }
  },
  mounted() {
    this.options.data = this.dataValues;
  }
};
</script>

<style lang="scss">
.slider {
  width: 100%;
}
.slider-container {
  width: 100%;
  padding: 30px 12px;
}
.vue-slider-dot-tooltip-inner {
  font-size: 14px;
  white-space: nowrap;
  padding: 2px 5px;
  min-width: 20px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  border-color: var(--md-theme-default-primary, #9c27b0);
  background-color: var(--md-theme-default-primary, #9c27b0);
  box-sizing: content-box;
  opacity: 0.85;
}
</style>
